<!-- <div class="mobile-fix-menu"></div> -->
<div class="container-fluid custom-padding">
    <div class="header-section">
        <div class="header-left">
            <div class="brand-logo">
                <a [routerLink]="['/']">
                    <img src="assets/images/logo/logo.png" 
                         alt="logo" 
                         class="logo-img logo-light"
                         [class.hidden]="commonServices.dark">
                    <img src="assets/images/logo/logo.png" 
                         alt="logo" 
                         class="logo-img logo-dark"
                         [class.hidden]="!commonServices.dark">
                </a>
            </div>

            <nav class="header-nav">
                <ul>
                    <li [class.active]="isLinkActive('/profile/timeline')">
                        <a (click)="handleAuthenticatedNavigation(['/profile/timeline'])" style="cursor: pointer;" class="nav-link">
                            <span translate="videos">Vidéos</span>
                            @if (isAuthenticated && profil?.rang === 'fan' && headerNotificationService.acceptedVideosCount() > 0) {
                                <span class="count-badge">{{ headerNotificationService.acceptedVideosCount() }}</span>
                            }
                        </a>
                    </li>
                    <li [class.active]="isLinkActive('/profile/requests')">
                        <a (click)="handleAuthenticatedNavigation(['/profile/requests'])" style="cursor: pointer;" class="nav-link">
                            <span translate="requests">Demandes</span>
                            @if (isAuthenticated && profil?.rang === 'star' && headerNotificationService.fanRequestsCount() > 0) {
                                <span class="count-badge">{{ headerNotificationService.fanRequestsCount() }}</span>
                            }
                        </a>
                    </li>
                    <li [class.active]="isLinkActive('/streams')">
                        <a href="javascript:void(0)" (click)="handleLiveClick(); $event.preventDefault()">
                            <span>Live</span>
                        </a>
                    </li>
                    <li [class.active]="isLinkActive('/profile/friends')">
                        <a [routerLink]="['/profile/friends']">
                            <span>Célébrités</span>
                        </a>
                    </li>
                </ul>
            </nav>
            
        </div>

        <div class="header-center">
            <app-search-box></app-search-box>
        </div>

        <div class="header-right">
            <div class="header-actions">
                @if (!isMobileScreen) {
                    <!-- Sélecteur de langue (masqué sur mobile) -->
                    <div class="language-selector-pill" (clickOutside)="closeLanguageDropdown()">
                        <div class="current-lang" (click)="toggleLanguageDropdown()">
                            <img [src]="'assets/images/flags/' + getLanguageFlag(currentLanguage) + '.png'"
                                [alt]="currentLanguage" class="flag-icon">
                        </div>
                        <div class="language-dropdown" [class.show]="isLanguageDropdownOpen">
                            <ul class="language-list">
                                <li *ngIf="currentLanguage !== 'Français'" (click)="changeLanguage('fr')">
                                    <img src="assets/images/flags/fr.png" alt="Français" class="flag-icon">
                                    <span>Français</span>
                                </li>
                                <li *ngIf="currentLanguage !== 'English'" (click)="changeLanguage('en')">
                                    <img src="assets/images/flags/en.png" alt="English" class="flag-icon">
                                    <span>English</span>
                                </li>
                                <li *ngIf="currentLanguage !== 'Lingala'" (click)="changeLanguage('cd')">
                                    <img src="assets/images/flags/cd.png" alt="Lingala" class="flag-icon">
                                    <span>Lingala</span>
                                </li>
                                <li *ngIf="currentLanguage !== 'Kiswahili'" (click)="changeLanguage('globe')">
                                    <img src="assets/images/flags/globe.png" alt="Kiswahili" class="flag-icon">
                                    <span>Kiswahili</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="mode-toggle" (click)="commonServices.changeMode()">
                        <span class="material-icons">{{ commonServices.dark ? 'light_mode' : 'dark_mode' }}</span>
                    </div>

                    <div class="vertical-divider"></div>
                }

                @if (isMobileScreen) {
                    <button type="button" class="mobile-search-icon"
                        (click)="openMobileSearch()"
                        aria-label="Ouvrir la recherche">
                        <span class="material-icons">search</span>
                    </button>
                }

                <div class="profile-section">
                    <app-user-profile
                        [useMobileMenu]="isMobileScreen"
                        [unreadRequestsCount]="headerNotificationService.fanRequestsCount()"
                        [isStar]="profil?.rang === 'star'"
                        (userClick)="openMobileOffcanvas()">
                    </app-user-profile>
                    <!-- <button type="button" class="mobile-offcanvas-breadcrumb"
                        (click)="openMobileOffcanvas()"
                        aria-label="Ouvrir le menu">
                        <span class="breadcrumb-icon">
                            <span class="breadcrumb-bar"></span>
                            <span class="breadcrumb-bar"></span>
                            <span class="breadcrumb-bar"></span>
                        </span>
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</div>

@if (isDropdownOpen) {
    <div class="dropdown-overlay" (click)="closeDropdown()"></div>
    <div class="dropdown-content">
        <ul class="friend-list"></ul>
    </div>
}

<!-- Recherche sur mobile -->
@if (mobileSearchOpen) {
    <div class="mobile-search-overlay" (click)="closeMobileSearch()" role="button" tabindex="0" (keydown.escape)="closeMobileSearch()"></div>
    <div class="mobile-search-panel" (click)="$event.stopPropagation()">
        <div class="mobile-search-header">
            <span class="mobile-search-title">Recherche</span>
            <button type="button" class="mobile-search-close" (click)="closeMobileSearch()" aria-label="Fermer">
                <span class="material-icons">close</span>
            </button>
        </div>
        <div class="mobile-search-content">
            <app-search-box></app-search-box>
        </div>
    </div>
}

<!-- Menu mobile -->
@if (mobileOffcanvasOpen) {
    <div class="mobile-offcanvas-overlay" (click)="closeMobileOffcanvas()" role="button" tabindex="0" (keydown.escape)="closeMobileOffcanvas()"></div>
    <div class="mobile-offcanvas-panel">
        <div class="mobile-offcanvas-header">
            <span>YokaStar</span>
            <button type="button" class="mobile-offcanvas-close" (click)="closeMobileOffcanvas()" aria-label="Fermer">
                <span class="material-icons">close</span>
            </button>
        </div>
        @if (isAuthenticated) {
            <div class="mobile-offcanvas-user">
                <div class="mobile-offcanvas-avatar-wrapper">
                    <div class="mobile-offcanvas-avatar"
                        [style.backgroundImage]="'url(' + (profil?.profile_picture || 'assets/images/avatar.jpeg') + ')'">
                    </div>
                </div>
                <div class="mobile-offcanvas-user-info">
                    <span class="user-name">{{ profil?.name }}</span>
                </div>
            </div>
        }
        <nav class="mobile-offcanvas-nav">
            <ul>
                <li [class.active]="isLinkActive('/profile/timeline')">
                    <a (click)="closeMobileOffcanvas(); handleAuthenticatedNavigation(['/profile/timeline'])" href="javascript:void(0)" class="mobile-offcanvas-link">
                        <span class="material-icons">video_library</span>
                        <span translate="videos">Vidéos</span>
                        @if (isAuthenticated && profil?.rang === 'fan' && headerNotificationService.acceptedVideosCount() > 0) {
                            <span class="count-badge">{{ headerNotificationService.acceptedVideosCount() }}</span>
                        }
                    </a>
                </li>
                <li [class.active]="isLinkActive('/profile/requests')">
                    <a (click)="closeMobileOffcanvas(); handleAuthenticatedNavigation(['/profile/requests'])" href="javascript:void(0)" class="mobile-offcanvas-link">
                        <span class="material-icons">assignment</span>
                        <span translate="requests">Demandes</span>
                        @if (isAuthenticated && profil?.rang === 'star' && headerNotificationService.fanRequestsCount() > 0) {
                            <span class="count-badge">{{ headerNotificationService.fanRequestsCount() }}</span>
                        }
                    </a>
                </li>
                <li [class.active]="isLinkActive('/streams')">
                    <a (click)="closeMobileOffcanvas(); handleLiveClick(); $event.preventDefault()" href="javascript:void(0)" class="mobile-offcanvas-link">
                        <span class="material-icons">live_tv</span>
                        <span>Live</span>
                    </a>
                </li>
                <li [class.active]="isLinkActive('/profile/friends')">
                    <a [routerLink]="['/profile/friends']" (click)="closeMobileOffcanvas()" class="mobile-offcanvas-link">
                        <span class="material-icons">people</span>
                        <span>Célébrités</span>
                    </a>
                </li>
                <li class="mobile-offcanvas-lang" (clickOutside)="closeOffcanvasLanguageDropdown()">
                    <button type="button" class="mobile-offcanvas-lang-trigger" (click)="toggleOffcanvasLanguageDropdown(); $event.stopPropagation()">
                        <span class="material-icons">language</span>
                        <span>Langues</span>
                        <img [src]="'assets/images/flags/' + getLanguageFlag(currentLanguage) + '.png'" [alt]="currentLanguage" class="flag-icon">
                        <span class="material-icons mobile-offcanvas-lang-chevron" [class.open]="isOffcanvasLangOpen">expand_more</span>
                    </button>
                    <ul class="mobile-offcanvas-lang-dropdown" [class.show]="isOffcanvasLangOpen">
                        <li (click)="changeLanguage('fr'); $event.stopPropagation()">
                            <img src="assets/images/flags/fr.png" alt="Français" class="flag-icon">
                            <span>Français</span>
                        </li>
                        <li (click)="changeLanguage('en'); $event.stopPropagation()">
                            <img src="assets/images/flags/en.png" alt="English" class="flag-icon">
                            <span>English</span>
                        </li>
                        <li (click)="changeLanguage('cd'); $event.stopPropagation()">
                            <img src="assets/images/flags/cd.png" alt="Lingala" class="flag-icon">
                            <span>Lingala</span>
                        </li>
                        <li (click)="changeLanguage('globe'); $event.stopPropagation()">
                            <img src="assets/images/flags/globe.png" alt="Kiswahili" class="flag-icon">
                            <span>Kiswahili</span>
                        </li>
                    </ul>
                </li>
                <li>
                    <a (click)="commonServices.changeMode()" href="javascript:void(0)" class="mobile-offcanvas-link">
                        <span class="material-icons">{{ commonServices.dark ? 'light_mode' : 'dark_mode' }}</span>
                        <span>{{ commonServices.dark ? 'Mode clair' : 'Mode sombre' }}</span>
                    </a>
                </li>
                <li [class.active]="isLinkActive('/profile/timeline')">
                    <a (click)="closeMobileOffcanvas(); handleAuthenticatedNavigation(['/profile/timeline'])" href="javascript:void(0)" class="mobile-offcanvas-link">
                        <span class="material-icons">person</span>
                        <span>Profil</span>
                    </a>
                </li>
                @if (isAuthenticated) {
                    <li>
                        <a (click)="closeMobileOffcanvas(); logOut()" href="javascript:void(0)" class="mobile-offcanvas-link mobile-offcanvas-link-logout">
                            <span class="material-icons">logout</span>
                            <span>Se déconnecter</span>
                        </a>
                    </li>
                }
            </ul>
        </nav>
    </div>
}
